import PeopleIcon from '@mui/icons-material/People';
import { KomboIntegrationStatusDTOStatusEnum, TenantDTOAdditionalFeaturesEnum } from 'probonio-shared-ui/api';
import { useTenant } from 'probonio-shared-ui/module/me';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useKomboIntegrationsList } from '../../kombo/kombo-queries';
import { TutorialStepDefinition } from '../TutorialStep';

export function useIntegrationHRSystemStep(): TutorialStepDefinition {
  const { t } = useTranslation('tutorialModule');
  const { tenant } = useTenant();

  const hasKombo =
    !!tenant && !tenant.hrSystemApiKey && Boolean(tenant.additionalFeatures?.includes(TenantDTOAdditionalFeaturesEnum.Kombo));

  const { data: komboIntegrations, isLoading: komboLoading } = useKomboIntegrationsList({ enabled: hasKombo });

  const komboCompleted = Boolean(komboIntegrations?.results?.some(i => i.status === KomboIntegrationStatusDTOStatusEnum.Active));

  const completed = hasKombo ? komboCompleted : Boolean(tenant?.hrSystemApiKey && tenant?.hrSystemApiSecret);
  const loading = !tenant || (hasKombo && komboLoading);
  const path = hasKombo ? '/settings/kombo' : '/settings/hrSystem';

  return useMemo(
    () => ({
      ...(t('steps.integrationHRSystem', { returnObjects: true }) as {
        label: string;
        description: string;
        help: string;
        buttonText: string;
      }),
      path,
      buttonIcon: PeopleIcon,
      loading,
      completed,
    }),
    [completed, loading, path, t],
  );
}
